import { useEffect, useState } from 'react';
import { hashSessionToken } from '@/lib/sessionToken';

/** SHA-256 hash of the current access token, or null while loading / unsigned-out. */
export function useSessionTokenHash(accessToken: string | undefined): string | null {
  const [hash, setHash] = useState<string | null>(null);

  useEffect(() => {
    if (!accessToken) {
      setHash(null);
      return;
    }

    let cancelled = false;
    void hashSessionToken(accessToken).then((value) => {
      if (!cancelled) setHash(value);
    });

    return () => {
      cancelled = true;
    };
  }, [accessToken]);

  return hash;
}
